var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.checkPermission(["chartView"])
    ? _c("div", { staticClass: "card-wrapper" }, [
        _vm._m(0),
        _vm.isLoading
          ? _c("div", { staticClass: "card-content" }, [
              _c("div", { staticClass: "loading-text" }, [
                _vm._v("Đang tải dữ liệu..."),
              ]),
            ])
          : _c(
              "div",
              { staticClass: "card-content" },
              [
                _vm.checkPermission(["chartView_student_information_in_school"])
                  ? _c(
                      "el-row",
                      { staticClass: "stats-row", attrs: { gutter: 16 } },
                      [
                        _c("el-col", { attrs: { span: 6 } }, [
                          _c("div", { staticClass: "summary-card tone-1" }, [
                            _c("p", { staticClass: "summary-title" }, [
                              _vm._v("Học sinh"),
                            ]),
                            _c("div", { staticClass: "summary-line" }, [
                              _c("i", { staticClass: "el-icon-user-solid" }),
                              _c("span", [_vm._v("Tổng số")]),
                              _c("b", [
                                _vm._v(
                                  _vm._s(_vm.statisticalData.kidsTotal.total)
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "summary-line" }, [
                              _c("i", { staticClass: "el-icon-user-solid" }),
                              _c("span", [_vm._v("Đang học")]),
                              _c("b", [
                                _vm._v(
                                  _vm._s(_vm.statisticalData.kidsTotal.study)
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "summary-line" }, [
                              _c("i", { staticClass: "el-icon-user-solid" }),
                              _c("span", [_vm._v("Bảo lưu")]),
                              _c("b", [
                                _vm._v(
                                  _vm._s(_vm.statisticalData.kidsTotal.reserve)
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "summary-line" }, [
                              _c("i", { staticClass: "el-icon-user-solid" }),
                              _c("span", [_vm._v("Chờ học")]),
                              _c("b", [
                                _vm._v(
                                  _vm._s(_vm.statisticalData.kidsTotal.wait)
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                        _c("el-col", { attrs: { span: 6 } }, [
                          _c("div", { staticClass: "summary-card tone-2" }, [
                            _c("p", { staticClass: "summary-title" }, [
                              _vm._v("Điểm danh"),
                            ]),
                            _c("div", { staticClass: "summary-line" }, [
                              _c("i", {
                                staticClass: "el-icon-document-checked",
                              }),
                              _c("span", [_vm._v("Đã điểm danh")]),
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.statisticalData.attendanceTotal
                                      .attendaceYes
                                  )
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "summary-line" }, [
                              _c("i", {
                                staticClass: "el-icon-document-delete",
                              }),
                              _c("span", [_vm._v("Chưa điểm danh")]),
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.statisticalData.attendanceTotal
                                      .attendaceNo
                                  )
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "summary-line" }, [
                              _c("i", { staticClass: "el-icon-tableware" }),
                              _c("span", [_vm._v("Đã điểm danh ăn")]),
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.statisticalData.attendanceTotal
                                      .attendanceEatYes
                                  )
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "summary-line" }, [
                              _c("i", { staticClass: "el-icon-tableware" }),
                              _c("span", [_vm._v("Chưa điểm danh ăn")]),
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.statisticalData.attendanceTotal
                                      .attendanceEatNo
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                        _c("el-col", { attrs: { span: 6 } }, [
                          _c("div", { staticClass: "summary-card tone-3" }, [
                            _c("p", { staticClass: "summary-title" }, [
                              _vm._v("Đón trả"),
                            ]),
                            _c("div", { staticClass: "summary-line" }, [
                              _c("i", { staticClass: "el-icon-user-solid" }),
                              _c("span", [_vm._v("Đi học")]),
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.statisticalData.leaveTotal.goSchool
                                  )
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "summary-line" }, [
                              _c("i", { staticClass: "el-icon-user-solid" }),
                              _c("span", [_vm._v("Đã về")]),
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.statisticalData.leaveTotal.leaveYes
                                  )
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "summary-line" }, [
                              _c("i", { staticClass: "el-icon-user-solid" }),
                              _c("span", [_vm._v("Chưa về")]),
                              _c("b", [
                                _vm._v(
                                  _vm._s(_vm.statisticalData.leaveTotal.leaveNo)
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "summary-line" }, [
                              _c("i", { staticClass: "el-icon-user-solid" }),
                              _c("span", [_vm._v("Đón muộn")]),
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.statisticalData.leaveTotal.pickupLater
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                        _c("el-col", { attrs: { span: 6 } }, [
                          _c("div", { staticClass: "summary-card tone-4" }, [
                            _c("p", { staticClass: "summary-title" }, [
                              _vm._v("Khác"),
                            ]),
                            _c("div", { staticClass: "summary-line" }, [
                              _c("i", {
                                staticClass: "el-icon-chat-line-square",
                              }),
                              _c("span", [_vm._v("Lời nhắn")]),
                              _c("b", [
                                _vm._v(
                                  _vm._s(_vm.statisticalData.otherTotal.message)
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "summary-line" }, [
                              _c("i", { staticClass: "el-icon-edit-outline" }),
                              _c("span", [_vm._v("Dặn thuốc")]),
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.statisticalData.otherTotal.medicine
                                  )
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "summary-line" }, [
                              _c("i", { staticClass: "el-icon-user-solid" }),
                              _c("span", [_vm._v("Nghỉ học")]),
                              _c("b", [
                                _vm._v(
                                  _vm._s(_vm.statisticalData.otherTotal.absent)
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "summary-line" }, [
                              _c("i", {
                                staticClass: "el-icon-document-remove",
                              }),
                              _c("span", [_vm._v("Đơn chưa duyệt")]),
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.statisticalData.otherTotal
                                      .absentLetterNoConfirm
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.checkPermission(["chartView_plan_go_to_school"])
                  ? _c(
                      "div",
                      { staticClass: "future-section" },
                      [
                        _c("p", { staticClass: "future-title" }, [
                          _vm._v("Dự kiến đi học"),
                        ]),
                        _vm.safeLearnFutureList.length
                          ? _c(
                              "el-row",
                              { attrs: { gutter: 16 } },
                              _vm._l(
                                _vm.safeLearnFutureList,
                                function (item, index) {
                                  return _c(
                                    "el-col",
                                    { key: index, attrs: { span: 6 } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "future-card",
                                          class: `future-card--${index + 1}`,
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "future-label" },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-date",
                                              }),
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(item.text) +
                                                  " - " +
                                                  _vm._s(
                                                    _vm._f("formatDayMonth")(
                                                      item.date
                                                    )
                                                  ) +
                                                  "\n            "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "future-number" },
                                            [_vm._v(_vm._s(item.number))]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            )
                          : _c("div", { staticClass: "chart-empty" }, [
                              _vm._v("Chưa có dữ liệu dự kiến đi học"),
                            ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("div", [
        _c("p", { staticClass: "card-title" }, [_vm._v("Thống kê tổng quan")]),
        _c("p", { staticClass: "card-subtitle" }, [
          _vm._v("Số liệu trong ngày"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }